import classNames from 'classnames'
import Image from 'next/image'
import { useRouter } from 'next/router'
import React from 'react'

import Routes from '../../../utils/routes'
import styles from './ContentsTool.module.scss'

type Props = {
  hidden?: boolean
}

const BlogBanner: React.FC<Props> = ({ hidden }) => {
  const router = useRouter()

  const utmSource = 'blog'
  const utmContent = router.asPath.split('?')[0].replaceAll('/', '')
  const utmMedium = 'sidebar_banner'

  if (hidden) return <div />
  return (
    <a
      className={classNames(styles.contentsMenu, styles.blogBanner)}
      href={Routes.GENERATOR + `?utm_source=${utmSource}&utm_content=${utmContent}&utm_medium=${utmMedium}`}
      target='_blank'
      rel='noopener noreferrer'
    >
      <div className={styles.blogBannerContainer}>
        <Image src={'/static/images/blog-banner.png'} layout='fill' />
      </div>
    </a>
  )
}

export default BlogBanner
